import type { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/god/graph',
    name: 'god-graph',
    component: () => import('./NetworkGraph.vue'),
  },
  {
    path: '/god/graph/:orgDomain',
    name: 'god-graph-sales',
    component: () => import('./NetworkGraph.vue'),
    props: true,
  },
  {
    path: '/zeus/federated-graph',
    name: 'zeus-federated-graph',
    component: () => import('@/modules/sales-mock-network-graph/CustomizableFederatedGraph.vue'),
  },
] satisfies RouteRecordRaw[];
